import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CashDetailQueryModel from '../models/CashDetailQueryModel';
import CashModel from '../models/CashModel';
import Utility from '../../../app/utility';

interface CashDetailState {
    cashDetails: CashModel[],
    query: CashDetailQueryModel,
    triggerRefreshCashDetail: number,
    showCashDetailModal: boolean,
    closingBalance: number,
    cashCurrency: string
}

const initialState: CashDetailState = {
    cashDetails: [],
    query: {
        account: "",
        dateFrom: "",
        dateTo: "",
    } as CashDetailQueryModel,
    triggerRefreshCashDetail: 0,
    showCashDetailModal: false,
    closingBalance: 0,
    cashCurrency: ""
}

export const CashDetailSlice = createSlice({
    name: "CashDetail",
    initialState,
    reducers: {
        setCashDetails: (state, action: PayloadAction<CashModel[]>) => {
            state.cashDetails = action.payload;
        },
        setTriggerRefreshCashDetail: (state, action: PayloadAction<number>) => {
            state.triggerRefreshCashDetail = action.payload;
        },
        setShowCashDetailModal: (state, action: PayloadAction<boolean>) => {
            state.showCashDetailModal = action.payload;
        },
        setAccountInit: (state, action: PayloadAction<string>) => {
            state.query.account = action.payload;
            state.query.dateFrom = Utility.DateFormat.format(new Date(new Date().getFullYear(), 0, 1))
            state.query.dateTo = Utility.DateFormat.format(Utility.addDaysToDate(new Date(), 1));
        },
        setAccount: (state, action: PayloadAction<string>) => {
            state.query.account = action.payload;
        },
        setDateFrom: (state, action: PayloadAction<string>) => {
            state.query.dateFrom = action.payload;
        },
        setDateTo: (state, action: PayloadAction<string>) => {
            state.query.dateTo = action.payload;
        },
        setClosingBalance: (state, action: PayloadAction<number>) => {
            state.closingBalance = action.payload;
        },
        setCashCurrency: (state, action: PayloadAction<string>) => {
            state.cashCurrency = action.payload;
        },
    },
});

export const CashDetailSelector = createSelector(
    (state: RootState) => state.cashDetail,
    (data) => data
);

export const {
    setCashDetails,
    setTriggerRefreshCashDetail,
    setShowCashDetailModal,
    setAccountInit,
    setAccount,
    setDateFrom,
    setDateTo,
    setClosingBalance,
    setCashCurrency
} = CashDetailSlice.actions;

export default CashDetailSlice.reducer;